// Enums de la ressource Support (zorni-controller, voir support-api-integration.md).

export const HELP_REQUEST_STATUS = {
  OPEN: "OPEN",
  IN_PROGRESS: "IN_PROGRESS",
  WAITING_ON_CUSTOMER: "WAITING_ON_CUSTOMER",
  RESOLVED: "RESOLVED",
  CLOSED: "CLOSED",
};

export const HELP_REQUEST_STATUS_OPTIONS = [
  { value: HELP_REQUEST_STATUS.OPEN, label: "Nouveau" },
  { value: HELP_REQUEST_STATUS.IN_PROGRESS, label: "En cours" },
  { value: HELP_REQUEST_STATUS.WAITING_ON_CUSTOMER, label: "En attente client" },
  { value: HELP_REQUEST_STATUS.RESOLVED, label: "Résolu" },
  { value: HELP_REQUEST_STATUS.CLOSED, label: "Fermé" },
];

export const INCIDENT_PRIORITY = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  CRITICAL: "CRITICAL",
};

export const INCIDENT_PRIORITY_OPTIONS = [
  { value: INCIDENT_PRIORITY.LOW, label: "Faible" },
  { value: INCIDENT_PRIORITY.MEDIUM, label: "Normale" },
  { value: INCIDENT_PRIORITY.HIGH, label: "Haute" },
  { value: INCIDENT_PRIORITY.CRITICAL, label: "Critique" },
];

// Distinct de l'EntityTypeEnum (ORGANIZATION / ESTABLISHMENT) utilisé pour les rôles.
export const SUPPORT_ENTITY_TYPE = {
  TRIP: "TRIP",
  ESTABLISHMENT: "ESTABLISHMENT",
  PAYMENT: "PAYMENT",
  OTHER: "OTHER",
};

export const SUPPORT_ENTITY_TYPE_OPTIONS = [
  { value: SUPPORT_ENTITY_TYPE.TRIP, label: "Voyage" },
  { value: SUPPORT_ENTITY_TYPE.ESTABLISHMENT, label: "Établissement" },
  { value: SUPPORT_ENTITY_TYPE.PAYMENT, label: "Paiement" },
  { value: SUPPORT_ENTITY_TYPE.OTHER, label: "Autre" },
];

export const MESSAGE_SENDER_ROLE = {
  REQUESTER: "REQUESTER",
  SUPPORT_AGENT: "SUPPORT_AGENT",
};

export const AUDIT_EVENT_TYPE = {
  REQUEST_CREATED: "REQUEST_CREATED",
  INCIDENT_CREATED: "INCIDENT_CREATED",
  COMMENT_CREATED: "COMMENT_CREATED",
  STATUS_CHANGED: "STATUS_CHANGED",
  PRIORITY_CHANGED: "PRIORITY_CHANGED",
  ASSIGNEE_CHANGED: "ASSIGNEE_CHANGED",
};

export const AUDIT_EVENT_TYPE_META = {
  [AUDIT_EVENT_TYPE.REQUEST_CREATED]: { label: "Demande créée", ico: "fa-inbox" },
  [AUDIT_EVENT_TYPE.INCIDENT_CREATED]: { label: "Ticket créé", ico: "fa-ticket" },
  [AUDIT_EVENT_TYPE.COMMENT_CREATED]: { label: "Commentaire interne ajouté", ico: "fa-comment" },
  [AUDIT_EVENT_TYPE.STATUS_CHANGED]: { label: "Statut", ico: "fa-flag" },
  [AUDIT_EVENT_TYPE.PRIORITY_CHANGED]: { label: "Priorité", ico: "fa-signal" },
  [AUDIT_EVENT_TYPE.ASSIGNEE_CHANGED]: { label: "Assigné", ico: "fa-user-plus" },
};

const labelOf = (options) => (value) => options.find((o) => o.value === value)?.label || value || "—";

export const helpRequestStatusLabel = labelOf(HELP_REQUEST_STATUS_OPTIONS);
export const incidentPriorityLabel = labelOf(INCIDENT_PRIORITY_OPTIONS);
export const supportEntityTypeLabel = labelOf(SUPPORT_ENTITY_TYPE_OPTIONS);

export const OPEN_HELP_REQUEST_STATUSES = [
  HELP_REQUEST_STATUS.OPEN,
  HELP_REQUEST_STATUS.IN_PROGRESS,
  HELP_REQUEST_STATUS.WAITING_ON_CUSTOMER,
];

// Pagination support-api : 1re page = 0 ou 1, à confirmer avec l'équipe support-api.
// La page UI (Pagination) est toujours 1-based ; seule cette constante change.
export const SUPPORT_FIRST_PAGE = 0;
// La support-api impose sizePage >= 3.
export const SUPPORT_MIN_PAGE_SIZE = 3;

export const toSupportPagination = (uiPage, sizePage) => ({
  currentPage: uiPage - 1 + SUPPORT_FIRST_PAGE,
  sizePage: Math.max(SUPPORT_MIN_PAGE_SIZE, sizePage),
});
